// extracted by mini-css-extract-plugin
module.exports = {"embedEditor":"embed-editor___3v_yT"};